module.exports = __webpack_public_path__ + "img/share.4fc3ea3c.png";